/* eslint-disable react/prop-types */ // TODO: add props
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const LegacyBreadcrumb = ({ url, anchor, children }) => {
  if (!url) {
    return <span>{children}</span>;
  }

  let LinkComponent;
  const linkProps = {};

  if (anchor) {
    linkProps.href = url;
    LinkComponent = 'a';
  } else {
    linkProps.to = url;
    LinkComponent = Link;
  }

  return <LinkComponent {...linkProps}>{children}</LinkComponent>;
};

const LegacyBreadcrumbs = ({ breadcrumbs }) => {
  if (!breadcrumbs) {
    return null;
  }

  return (
    <nav id="breadcrumbs">
      <ul>
        {breadcrumbs
          .filter((bc) => !!bc)
          .map((bc, i) => (
            <li key={i}>
              <LegacyBreadcrumb url={bc.url} anchor={bc.anchor}>
                {bc.label}
              </LegacyBreadcrumb>
            </li>
          ))}
      </ul>
    </nav>
  );
};

LegacyBreadcrumbs.defaultProps = {
  breadcrumbs: [],
};

LegacyBreadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string,
      anchor: PropTypes.bool,
    })
  ),
};

export default LegacyBreadcrumbs;
